export default __webpack_public_path__ + "locales/pt/Common.json?hash=8941a3ac5532beb23ed0420cad0e8182";